import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface GuestSignInPromptModalProps {
    isOpen: boolean;
    onClose: () => void;
}

/**
 * הצעה לאורח להירשם ולשמור את מה שכבר קרא.
 *
 * אורח קורא, מקבל ציון, ובסוף הביקור הכל נמחק. ההצעה הזאת עולה אחרי
 * הקריאה הראשונה, השלישית והשביעית, ואף פעם לא באמצע קריאה.
 *
 * "אחר כך" סוגר בלי שום עונש: הילד חוזר לקרוא, וזה מה שחשוב.
 */
const GuestSignInPromptModal: React.FC<GuestSignInPromptModalProps> = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const goToSignIn = () => {
        onClose();
        // מסך הכניסה מחזיק את כל הדרכים להיכנס: Google וקוד כיתה
        localStorage.clear();
        sessionStorage.clear();
        navigate('/');
    };

    return (
        <Dialog open={isOpen} onClose={onClose} className="message-modal guest-sign-in-prompt">
            <DialogTitle component="h3">
                <EmojiEventsIcon
                    sx={{ color: 'white', fontSize: 64, background: '#b689e3', borderRadius: '50%' }}
                />
                {t('guestSignInPromptTitle')}
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', padding: '32px' }}>
                <div style={{ fontSize: '16px', lineHeight: '24px' }}>
                    {t('guestSignInPromptMessage')}
                </div>
            </DialogContent>
            <DialogActions style={{ marginBottom: 0, justifyContent: 'center', gap: '12px' }}>
                <Button onClick={onClose} variant="text">
                    {t('guestSignInPromptLater')}
                </Button>
                <Button onClick={goToSignIn} variant="contained">
                    {t('guestSignInPromptConfirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GuestSignInPromptModal;
